import CurrencyFormatter from 'utils/currency-formatter';

export default function formatCurrency(value) {
  return CurrencyFormatter.format(value);
}
